import type { InputHTMLAttributes, PropsWithChildren } from 'react'
import { useMemo } from 'react'

import { Radio } from './components/Radio'
import { RadioCard } from './components/RadioCard'
import { useRadioControl } from './hooks/useRadioControl'
import { RadioGroupContext } from './RadioGroupContext'
import { RadioGroupStyled } from './styles/RadioGroupStyled'
import { Space } from '@ui/elements/Space'

export interface IRadioGroupProps {
  name: string
  value?: string
  onChange?: InputHTMLAttributes<HTMLInputElement>['onChange']
  id?: string
  'aria-labelledby'?: string
}

export const RadioGroup = ({
  name,
  value: valueProp,
  onChange: onChangeProp = () => undefined,
  children,
  id,
  'aria-labelledby': ariaLabelledBy,
}: PropsWithChildren<IRadioGroupProps>) => {
  const { value, onChange } = useRadioControl({
    valueProp,
    onChangeProp,
  })

  const contextValues = useMemo(
    () => ({
      name,
      value,
      onChange,
    }),
    [name, value, onChange]
  )

  return (
    <RadioGroupContext.Provider value={contextValues}>
      <RadioGroupStyled role='radiogroup' aria-labelledby={ariaLabelledBy}>
        <input
          className='group-value-input'
          type='text'
          id={id}
          value={value || ''}
          readOnly
        />
        <Space>{children}</Space>
      </RadioGroupStyled>
    </RadioGroupContext.Provider>
  )
}

RadioGroup.Item = Radio
RadioGroup.CardItem = RadioCard
